import { gql } from "@apollo/client";

export const getStatuses = gql`
    query getStatuses {
        status {
            status_id
            name
            order
            default_status_translations {
                status_id
                language {
                    language_id
                    name
                    code
                }
                translated_name
            }
        }
    }
`;
